import { Component, Inject, OnInit } from '@angular/core';
import { AetSafetyDashboardService } from 'src/app/services/aet-safety-dashboard.service';
import { DatePipe } from '@angular/common';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-safety',
  templateUrl: './edit-safety.component.html',
  styleUrls: ['./edit-safety.component.scss'],
  standalone: false // NOSONAR
})
export class EditSafetyComponent implements OnInit {
  heading: any;
  domicile: any;
  domicileList: any;
  errormsg: any;
  selected_position_id: any;
  yesCheck: any;
  noCheck: any;
  routeName: any;
  comments: any;
  trailer;
  incidentTypeDetails;
  severity;
  region = 'LCD';
  lp = 1;
  incidentDate;
  incidentTime;
  plannedDate;
  isChecked: boolean = true;
  Fatality;
  Amputation;
  LOH;
  Fracture;
  Injury;
  Illness;
  LOS;
  headInjuriry;
  Hospitalisation;
  nearMiss;
  Burn;
  Stop6;
  Property;
  Other;
  incidentTypes = [];
  severityDropDown;
  lpDropDown;
  regionDropDown;
  reportType: any;
  deleteAccessible: boolean = true;
  isAccessible: boolean = true;
  maxi = 1000;
  maxiDetails = 2000;
  check = false
  lastUpdatedBy: any;
  constructor(
    public dialogRef: MatDialogRef<EditSafetyComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: any,
    private readonly aetSafetyDashboardService: AetSafetyDashboardService,
    private readonly DatePipe: DatePipe,
    private readonly constants: Constants,
    private readonly aetStateService: AetStateService,
  ) { }

  ngOnInit(): void {

    //(time.split(':'))[0]
    const incidentDateTime = this.dataStore.data.incidentDate;
    const incidentTime = incidentDateTime.substr(incidentDateTime.length - 5);
    this.incidentTime = incidentTime;


    // this.checkRoles();
    this.heading = this.dataStore.header;
    this.routeName = this.dataStore.data.puRoute;
    this.comments = this.dataStore.data.incidentSummary;
    this.trailer = this.dataStore.data.trailer;
    this.incidentTypeDetails = this.dataStore.data.incidentTypeDetails;
    this.incidentDate = this.dataStore.data.incidentDate;
    this.plannedDate = this.dateFormatter(this.dataStore.data.routeDate);
    this.Fatality = this.dataStore.data.fa;
    if (this.dataStore.data.fa == 4) {    // NOSONAR
      this.incidentTypes.push('FATALITY');
    }
    this.Amputation = this.dataStore.data.am;
    if (this.dataStore.data.am == 4) {  // NOSONAR
      this.incidentTypes.push('AMPUTATION');
    }
    this.Fracture = this.dataStore.data.fr;
    if (this.dataStore.data.fr == 4) {  // NOSONAR
      this.incidentTypes.push('FRACTURE');
    }
    this.LOH = this.dataStore.data.loh;
    if (this.dataStore.data.loh == 4) {   // NOSONAR
      this.incidentTypes.push('LOSS OF HEARING');
    }
    this.Injury = this.dataStore.data.inj;
    if (this.dataStore.data.inj == 4) {  // NOSONAR
      this.incidentTypes.push('INJURY');
    }
    this.Illness = this.dataStore.data.ilj;
    if (this.dataStore.data.ilj == 4) {   // NOSONAR
      this.incidentTypes.push('ILLNESS');
    }
    this.LOS = this.dataStore.data.los;
    if (this.dataStore.data.los == 4) {   // NOSONAR
      this.incidentTypes.push('LOSS OF SIGHT');
    }
    this.headInjuriry = this.dataStore.data.hj;
    if (this.dataStore.data.hj == 4) {   // NOSONAR
      this.incidentTypes.push('HEAD INJURY');
    }
    this.Hospitalisation = this.dataStore.data.ho;
    if (this.dataStore.data.ho == 4) {   // NOSONAR
      this.incidentTypes.push('HOSPITALIZATION');
    }
    this.nearMiss = this.dataStore.data.nht;
    if (this.dataStore.data.nht == 4) {   // NOSONAR
      this.incidentTypes.push('NEAR MISS HIT');
    }
    this.Burn = this.dataStore.data.bu;
    if (this.dataStore.data.bu == 4) {   // NOSONAR
      this.incidentTypes.push('BURN');
    }
    this.Stop6 = this.dataStore.data.st;
    if (this.dataStore.data.st == 4) {   // NOSONAR
      this.incidentTypes.push('STOP');
    }
    this.Property = this.dataStore.data.pd;
    if (this.dataStore.data.pd == 4) {  // NOSONAR
      this.incidentTypes.push('PROPERTY DAMAGE');
    }
    this.Other = this.dataStore.data.ot;
    if (this.dataStore.data.ot == 4) {  // NOSONAR
      this.incidentTypes.push('OTHER');
    }

    this.severityDropDown = this.dataStore.severityDrpDown;
    this.regionDropDown = this.dataStore.regionDrpDown;
    this.lpDropDown = this.dataStore.vendorDrpDown;
    this.severity = this.severityDropDown?.find(
      (x) => x.value == this.dataStore.data.severity    // NOSONAR
    )?.value;
    this.region = this.regionDropDown?.find(
      (x) => x.label == this.dataStore.data.region || x.value == this.dataStore.data.region    // NOSONAR
    )?.value;
    this.lp = this.lpDropDown?.find(
      (x) => x.value == this.dataStore.data.logisticPoint    // NOSONAR
    )?.label;
    this.reportType = this.dataStore.data.reportType;
    this.incidentDate = this.DatePipe.transform(
      this.incidentDate?.substring(0, 10),
      'yyyy-MM-dd'
    );
    this.lastUpdatedBy = localStorage.getItem('loggedInUser');

  }
  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);


    // if (
    //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
    //   userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
    //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_AET_LP) ||
    //   userRoles.includes(this.constants.LIOS_UAC_General_User)
    // ) {

    // if (
    //   (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
    //   userRoles.includes(this.constants.LIOS_UAC_LP_Filter) ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
    //   userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
    //   userRoles.includes(this.constants.LIOS_UAC_AET_LP)
    // ) {

    if (
      (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin)) ||
      userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) ||
      userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) ||
      userRoles.includes(this.constants.LIOS_UAC_MTM_Planner)
    ) {
      this.deleteAccessible = true;

    }

  }
  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }
  dateFormatter(res) {
    return res ? moment(res).format('MM/DD/YYYY HH:mm') : null;
  }
  onInputBoxChanged(event) {
    if (event.target.checked) { this.incidentTypes.push(event.target.value); }
    else {
      this.incidentTypes = this.incidentTypes.filter(
        (item) => item != event.target.value  // NOSONAR
      );
    }

  }

  deleteEvent() {
    this.dialogRef.close({ event: 'onDeletePress', id: this.dataStore.data.safetyEventId });
  }

  validateForm(): boolean {
    if (this.comments?.length != 0 && this.incidentTypes?.length != 0 && this.trailer?.length != 0 && this.incidentTypeDetails?.length != 0) { // NOSONAR
      return true;
    }
    const errorfield = [];
    if (this.comments?.length == 0) {   // NOSONAR
      errorfield.push("Comments");
    }
    if (this.incidentTypes?.length == 0) {   // NOSONAR
      errorfield.push("Incident Types");
    }
    if (this.trailer?.length == 0) {   // NOSONAR
      errorfield.push("Trailer");
    }
    if (this.incidentTypeDetails?.length == 0) {   // NOSONAR
      errorfield.push("Incident Details");
    }
    this.errormsg = "Please give these details: " + errorfield.join(", ");
    return false;
  }

  saveClick(): void {
    this.check = true

    if (this.validateForm()) {
      this.errormsg = '';
      // this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      const updateObject = {
        safetyEventId: this.dataStore.data.safetyEventId,
        reportId: this.dataStore.data.reportId,
        reportType: this.dataStore.data.reportType,
        routeName: this.dataStore.data.routeName,
        routeDate: this.plannedDate.substring(0, 10),
        puroute: this.dataStore.data.routeName,
        incidentSummary: this.comments,
        incidentDate: `${this.incidentDate}${' '}${this.incidentTime}${':00'}`,
        severity: this.severity,
        logisticPoint: this.lpDropDown?.find((x) => x.label == this.lp)?.value,   // NOSONAR
        logisticPointId: this.lp,
        burnningTextValue: '',
        stopValue: 'MILD INJURY 26th', // what is this
        region: this.region,
        trailer: this.trailer,
        incidentTypeDetails: this.incidentTypeDetails,
        incidentDetails: this.incidentTypeDetails,
        incidentType: this.incidentTypes,
        lastUpdateBy: this.lastUpdatedBy,
      };
      // this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.aetSafetyDashboardService
        .updatesafetyDashboard(updateObject)
        .subscribe(
          (response) => {
            if (response == 'Success') {   // NOSONAR
              this.dialogRef.close({
                event: 'SaveEvent',
                responseType: 'success'
                // eventType: this.eventType,
              });
            } else {
              // do nothing
            }
          },
          (_error) => {
            //do nothing
          }
        );
    }
  }
}
